"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = void 0;
function getCookie(name) {
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieList = decodedCookie.split(';');
    name = name + '=';
    for (var _i = 0, cookieList_1 = cookieList; _i < cookieList_1.length; _i++) {
        var cookie = cookieList_1[_i];
        var startIndex = 0;
        while (cookie.charAt(startIndex) === ' ') {
            startIndex++;
        }
        cookie = cookie.substring(startIndex);
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return '';
}
exports.getCookie = getCookie;
//# sourceMappingURL=cookieUtils.js.map